
import { Component, Mixins } from "vue-property-decorator";
import { IFontSizeAutoAdjustable } from "../../../../../domain/document/items";
import { CommonComponentsAccessor } from "../../CommonComponentsAccessor";

@Component
export default class FontSizeAutoAdjustableMixin extends Mixins() {
  editingSource: IFontSizeAutoAdjustable;
  commonComponents: CommonComponentsAccessor;

  autoAdjustFontSizeWithRetry(): void {
    this.autoAdjustFontSize();

    // IME変換中にフォーカスを外したとき、更新イベントの直後にフォーカスを外したイベントが発生して、
    // 値が反映されていない状態で文字サイズ計算してしまうことがあるので対策している
    const beforeValue = this.editingSource.value;
    this.$nextTick(() => {
      if (beforeValue !== this.editingSource.value) {
        this.$logger.debug("文字サイズを再調整します。");
        this.autoAdjustFontSize();
      }
    });
  }

  autoAdjustFontSize(): void {
    const cloned = this.editingSource.clone() as IFontSizeAutoAdjustable;
    cloned.adjustFontSize();
    if (cloned.textStyle.adjustedFontSize === this.adjustedFontSize) {
      return;
    }
    // IME変換中にフォーカスを外したとき、更新イベントの直後にフォーカスを外したイベントが発生して、
    // 値が巻き戻ることがあるので対策している
    this.$nextTick(() => {
      if (this.editingSource.value === cloned.value) {
        this.editingSource = cloned;
      }
    });
    this.commonComponents.editors.extraPage.addOverflowedTextPage(cloned);
  }

  get adjustedFontSize(): number {
    return this.editingSource.textStyle.adjustedFontSize;
  }
}
